///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SystemInfoDTO } from '../../../generated/shared-types.model';
import { systemInfoFeatureKey, SystemInfoState } from './system-info.state';

export const selectSystemInfoState = createFeatureSelector<SystemInfoState>(systemInfoFeatureKey);

export const selectSystemInfo = createSelector(
    selectSystemInfoState,
    (systemInfoState: SystemInfoState): SystemInfoDTO => systemInfoState.info
);

export const selectEmailVerificationTokenLength = createSelector(
    selectSystemInfo,
    (systemInfo: SystemInfoDTO): number => systemInfo.emailVerificationTokenLength
);
